const themeData = document.body ? document.body.dataset : null;



if (themeData) {

  window.routes = {

    cart_add_url: themeData.cartAddUrl,

    cart_change_url: themeData.cartChangeUrl,

    cart_update_url: themeData.cartUpdateUrl,

    cart_url: themeData.cartUrl,

    predictive_search_url: themeData.predictiveSearchUrl

  };



  window.theme = window.theme || {};

  window.theme.settings = window.theme.settings || {};

  if (themeData.cartType) window.theme.settings.cart_type = themeData.cartType;

}



document.querySelectorAll('[role="button"]').forEach((button) => {

    button.addEventListener('keydown', (event) => {

        if (event.code === 'Enter' || event.code === 'Space') {

            event.preventDefault();

            event.target.click();

        }

    });

});



class MenuDrawer extends HTMLElement {

  constructor() {

    super();

    this.mainDetails = this.querySelector('details');

    this.summary = this.mainDetails.querySelector('summary');

    this.content = this.mainDetails.querySelector('.menu-drawer__content');

    this.closeButton = this.querySelector('.menu-drawer__close-button');



    this.addEventListener('click', this.onFocusOut.bind(this));

    this.mainDetails.addEventListener('toggle', this.onToggle.bind(this));

    if (this.closeButton) {

      this.closeButton.addEventListener('click', this.onClose.bind(this));

    }

  }



  onFocusOut(event) {

    const isInside = this.contains(event.target);

    if (!isInside) this.close();

  }



  onClose(event) {

    if(event) event.preventDefault();

    this.close();

  }



  onToggle() {

    if (!this.mainDetails.open) return;

    document.body.style.overflow = 'hidden';

    this.trapFocus();

  }



  close() {

    this.mainDetails.removeAttribute('open');

    document.body.style.overflow = '';

  }



  trapFocus() {

    const focusableElements = this.content.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    if (focusableElements.length > 0) focusableElements[0].focus();

  }

}

customElements.define('menu-drawer', MenuDrawer);



function fetchConfig(type = 'json') {

  return {

    method: 'POST',

    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }

  };

}



// Quantity Input - Used on product page and cart

if (!customElements.get('quantity-input')) {

  class QuantityInput extends HTMLElement {

    constructor() {

      super();

      this.input = this.querySelector('input');

      this.changeEvent = new Event('change', { bubbles: true });



      this.querySelectorAll('button').forEach(

        (button) => button.addEventListener('click', this.onButtonClick.bind(this))

      );

    }



    onButtonClick(event) {

      event.preventDefault();

      const previousValue = this.input.value;



      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();

      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    }

  }

  customElements.define('quantity-input', QuantityInput);

}



// Deferred Media - Lazy load videos and 3D models

if (!customElements.get('deferred-media')) {

  class DeferredMedia extends HTMLElement {

    constructor() {

      super();

      const poster = this.querySelector('.deferred-media__poster');

      if (poster) {

        poster.addEventListener('click', this.loadContent.bind(this));

      }

    }



    loadContent() {

      if (!this.getAttribute('loaded')) {

        const content = document.createElement('div');

        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        

        this.setAttribute('loaded', true);

        const poster = this.querySelector('.deferred-media__poster');

        if (poster) poster.remove();

        

        this.appendChild(content.querySelector('video, model-viewer, iframe'));

        

        // Auto-play video if present

        const video = this.querySelector('video');

        if (video) {

          video.play().catch(() => {});

        }

      }

    }

  }

  customElements.define('deferred-media', DeferredMedia);

}





/* ProductForm has been moved to assets/product-form.js to allow for better cart drawer handling */





class VariantRadios extends HTMLElement {

  constructor() {

    super();

    this.addEventListener('change', this.onVariantChange.bind(this));

  }



  onVariantChange() {

    this.updateOptions();

    this.updateMasterId();

    this.updateURL();

    this.updateVariantInput();

    this.updateMedia(); 

    this.updatePrice(); // Trigger Price Update

    this.updatePickupAvailability(); // Update pickup availability

    this.toggleAddButton(true, '', false);

  }



  updatePickupAvailability() {

    const pickUpAvailability = document.querySelector('pickup-availability');

    if (!pickUpAvailability || !this.currentVariant) return;



    if (this.currentVariant.available) {

      pickUpAvailability.setAttribute('available', '');

      pickUpAvailability.dataset.variantId = this.currentVariant.id;

      pickUpAvailability.fetchAvailability(this.currentVariant.id);

    } else {

      pickUpAvailability.removeAttribute('available');

      pickUpAvailability.innerHTML = '';

    }

  }



  updatePrice() {

    if (!this.currentVariant || !this.dataset.url) return;



    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;



    fetch(url)

      .then((response) => response.text())

      .then((responseText) => {

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const destination = document.getElementById(`price-${this.dataset.section}`);

        const source = html.getElementById(`price-${this.dataset.section}`);



        if (source && destination) {

            destination.innerHTML = source.innerHTML;

        }

        

        // Also update Price in the sticky header or other places if they existed

      });

  }



  updateMedia() {

    // 1. Find all media groups

    const mediaGroups = document.querySelectorAll('.product__media-gallery');

    

    // Count non-fallback galleries (color-specific galleries)

    const colorGalleries = Array.from(mediaGroups).filter(g => !g.hasAttribute('data-fallback'));

    

    // If there are no color-specific galleries, just keep the fallback visible and exit

    if (colorGalleries.length === 0) {

      // If variants have featured media, scroll to that media item in the default gallery

      if (this.currentVariant) {

        const featuredMediaId =

          this.currentVariant.featured_media?.id ||

          this.currentVariant.featured_image?.id ||

          this.currentVariant.featured_media_id ||

          this.currentVariant.featured_image_id;



        if (featuredMediaId) {

          const target = document.querySelector(

            `.product__media-item[data-media-id="${featuredMediaId}"]`

          );

          if (target) {

            target.scrollIntoView({ behavior: 'smooth', block: 'start' });

          }

        }

      }

      return;

    }

    

    // 2. Identify which option index is "Color" (Case insensitive check)

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    let colorIndex = -1;

    

    fieldsets.forEach((fieldset, index) => {

        const legend = fieldset.querySelector('legend');

        if (legend) {

            const legendText = legend.textContent.trim().toLowerCase();

            if (legendText === 'color' || legendText === 'colour') {

                colorIndex = index;

            }

        }

    });



    if (colorIndex === -1) return; // No color option found



    // 3. Get the selected color value (handleize to match Liquid's handleize filter)

    const rawValue = this.options[colorIndex];

    const selectedColor = rawValue

      .toLowerCase()

      .trim()

      .replace(/[^a-z0-9]+/g, '-')  // Replace non-alphanumeric with hyphens (like Shopify handleize)

      .replace(/^-+|-+$/g, '');      // Remove leading/trailing hyphens



    console.log('[updateMedia] Raw value:', rawValue, '| Normalized:', selectedColor);



    // 4. Show/hide galleries based on color match

    let matchFound = false;



    colorGalleries.forEach(group => {

        const groupColor = group.getAttribute('data-color');

        console.log('[updateMedia] Group color:', groupColor, '| Match:', groupColor === selectedColor);

        

        if (groupColor === selectedColor) {

            group.classList.add('is-active');

            group.style.display = '';

            matchFound = true;

        } else {

            group.classList.remove('is-active');

            group.style.display = 'none';

        }

    });



    // 5. Handle Fallback

    const fallbackGroup = document.querySelector('.product__media-gallery[data-fallback="true"]');

    if (fallbackGroup) {

        if (!matchFound) {

            // Show fallback if no color match found

            fallbackGroup.classList.add('is-active');

            fallbackGroup.style.display = '';

        } else {

            // Hide fallback when a specific color gallery is matched

            fallbackGroup.classList.remove('is-active');

            fallbackGroup.style.display = 'none';

        }

    }

    

    console.log('[updateMedia] Match found:', matchFound);

  }



  updateOptions() {

    this.options = Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {

      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;

    });

  }



  updateMasterId() {

    this.currentVariant = this.getVariantData().find((variant) => {

      return !variant.options.map((option, index) => {

        return this.options[index] === option;

      }).includes(false);

    });

  }



  updateURL() {

    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

  }



  updateVariantInput() {

    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);

    productForms.forEach((productForm) => {

      const input = productForm.querySelector('input[name="id"]');

      input.value = this.currentVariant ? this.currentVariant.id : '';

      input.dispatchEvent(new Event('change', { bubbles: true }));

    });

  }



  toggleAddButton(disable = true, text, modifyClass = true) {

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);

    if (!productForm) return;



    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;



    if (this.currentVariant) { // Variant Exists

       if (this.currentVariant.available) {

          addButton.removeAttribute('disabled');

          if (modifyClass) addButton.querySelector('span').textContent = 'Add to cart';

       } else {

          addButton.setAttribute('disabled', 'disabled');

          if (modifyClass) addButton.querySelector('span').textContent = 'Sold out';

       }

    } else { // Variant Does Not Exist (Combination invalid)

       addButton.setAttribute('disabled', 'disabled');

       if (modifyClass) addButton.querySelector('span').textContent = 'Unavailable';

    }

  }



  getVariantData() {

    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;

  }

}

customElements.define('variant-radios', VariantRadios);

